<ul class="pagination">
    <li *ngFor="let page of getPaginationPages()" [ngClass]="{'active': page === currentPage, 'dots': page === '...'}">
        <a *ngIf="page !== '...'" (click)="onPageClick(page)">{{ page }}</a>
        <span *ngIf="page === '...'">...</span>
    </li>
</ul>